import React from 'react';
import Skeleton from "../skeleton";

const QuestionSkeleton = () => {
    return (
        <div className="u_que-list">
            <div className="u_que-list-inner u_mb-20">
                <Skeleton width='100%' height='20px' className="u_mb-15"/>
                <Skeleton width='100%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
            </div>
            <div className="u_que-list-inner u_mb-20">
                <Skeleton width='100%' height='20px' className="u_mb-15"/>
                <Skeleton width='100%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
            </div>
            <div className="u_que-list-inner u_mb-20">
                <Skeleton width='100%' height='20px' className="u_mb-15"/>
                <Skeleton width='100%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
                <Skeleton width='40%' height='18px' className="u_mb-15"/>
            </div>
        </div>
    );
};

export default QuestionSkeleton;
